import { Header } from '../components/header.component';
import noAuctionImage from '../images/no-auction.png';

export interface noAuctionProps {
    upcomingDate?: Date;
}

export const NoAuction = ((props: noAuctionProps) => {
    return (
        <div className="h-100 d-flex flex-column justify-content-center align-items-center">
            <div className="w-100 mb-auto">
                <Header />
            </div>
            <div className="p-2 bg-darker">
                <img height="150x" src={noAuctionImage} alt="No current auction" />
            </div>
            <h3 className="text-avenir-re p-3 bg-darker">THE CAKE WAS A LIE</h3>
            <div className="mt-auto mb-5 border text-center py-4 px-5 bg-darker">
                {(props.upcomingDate) ?
                    <>
                        <h4 className="text-avenir-re text-uppercase mb-0 py-2 px-4">{props.upcomingDate.toLocaleString()}</h4>
                        <h5 className="text-avenir-ul mb-0 py-2 px-4">THE NEXT AUCTION WILL BEGIN</h5>
                    </>
                    : <h5 className="text-avenir-ul mb-0 py-2 px-4">THERE ARE NO SCHEDULED AUCTIONS IN THE NEAR FUTURE</h5>
                }
            </div>
        </div>
    );
});